"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _group = require("@/api/group");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      isAdd: true,
      activeName: 'first',
      formData: {
        id: '',
        //团名
        groupName: '',
        //成团人数
        buyCount: '',
        //有效期
        validHour: '',
        //活动限购
        allQuota: '',
        //单次限购
        oncQuota: '',
        //团长佣金比例
        leaderCommissionRate: 0,
        //凑团
        showGroup: 0,
        //模拟成团
        fictiStatus: 0,
        //开始时间
        startTime: '',
        //结束时间
        endTime: '',
        //sku
        groupBuySkuRequest: []
      },
      productList: [],
      //凑团
      showGroupSwitch: 0,
      //模拟成团
      fictiStatusSwitch: 0,
      time: '',
      rules: {
        groupName: [{
          required: true,
          message: '请输入活动名称',
          trigger: 'blur'
        }],
        buyCount: [{
          required: true,
          message: '请输入成团人数',
          trigger: 'blur'
        }],
        validHour: [{
          required: true,
          message: '请输入有效时间',
          trigger: 'blur'
        }],
        allQuota: [{
          required: true,
          message: '请输入活动限购数量',
          trigger: 'blur'
        }],
        oncQuota: [{
          required: true,
          message: '请输入单次限购数量',
          trigger: 'blur'
        }],
        startTime: [{
          required: true,
          message: '请选择活动时间',
          trigger: 'change'
        }]
      },
      activityId: '',
      type: '',
      visible: false
    };
  },
  created: function created() {
    if (this.$route.params.activityId) {
      this.type = this.$route.params.type;
      this.getInfo(this.$route.params.activityId);
      if (this.$route.params.type == 1) {
        this.activityId = this.$route.params.activityId;
        this.formData.id = this.$route.params.activityId;
      }
    }
  },
  methods: {
    openClose: function openClose(item) {
      if (item.visible) {
        this.$set(item, 'visible', false);
      } else {
        this.$set(item, 'visible', true);
      }
    },
    //编辑复制-数据回显
    getInfo: function getInfo(id) {
      var _this2 = this;
      (0, _group.groupBuyInfo)(id).then(function (res) {
        _this2.formData = res;
        _this2.time = [res.startTime, res.endTime];
        _this2.showGroupSwitch = res.showGroup == 0 ? false : true;
        _this2.fictiStatusSwitch = res.fictiStatus == 0 ? false : true;
        var editArr = [];
        res.groupBuyActivityProductResponseList.forEach(function (item) {
          if (item.groupBuyActivitySkuResponses.length) {
            var obj = {
              id: item.productId,
              name: item.productName,
              image: item.image,
              attrValue: []
            };
            item.groupBuyActivitySkuResponses.forEach(function (citem) {
              if (citem.attrValue.length) {
                obj.attrValue.push({
                  activePrice: citem.activePrice,
                  groupActivityId: citem.groupActivityId,
                  id: citem.id,
                  productId: citem.productId,
                  quotaShow: citem.quotaShow,
                  skuId: citem.skuId,
                  sku: citem.attrValue[0].sku,
                  image: citem.attrValue[0].image,
                  price: citem.attrValue[0].price,
                  stock: citem.attrValue[0].stock
                });
              }
            });
            editArr.push(obj);
          }
        });
        // this.formData.groupBuySkuRequest = editArr;
        _this2.productList = editArr;
      });
    },
    toGo: function toGo(formName) {
      var _this3 = this;
      this.$refs[formName].validate(function (valid) {
        if (valid) {
          _this3.activeName = 'second';
        } else {
          return false;
        }
      });
    },
    timeChange: function timeChange(e) {
      if (e) {
        this.formData.startTime = e[0];
        this.formData.endTime = e[1];
      } else {
        this.formData.startTime = '';
        this.formData.endTime = '';
      }
    },
    //模拟成团开关
    fictiStatus: function fictiStatus(e) {
      e ? this.formData.fictiStatus = 1 : this.formData.fictiStatus = 0;
    },
    //凑团开关
    showGroup: function showGroup(e) {
      if (e) {
        this.formData.showGroup = 1;
      } else {
        this.formData.fictiStatus = 0;
        this.formData.showGroup = 0;
        this.fictiStatusSwitch = 0;
      }
    },
    //添加商品
    addGoods: function addGoods() {
      var _this = this;
      this.$modalActivityProduct(function (row) {
        _this.listLoading = false;
        _this.getAttrValue(row);
      }, 'many', _this.productList, 0, 2
      // Number(_this.form.id),
      );
    },
    //删除商品
    deleteGoods: function deleteGoods(index) {
      var _this4 = this;
      this.$modalSure('要删除此商品吗？').then(function () {
        _this4.productList.splice(index, 1);
        _this4.$message({
          type: 'success',
          message: '删除成功!'
        });
      });
    },
    //获取商品
    getAttrValue: function getAttrValue(row) {
      var _this5 = this;
      var procuctList = row;
      row.forEach(function (item) {
        item.attrValue.forEach(function (citem) {
          if (!citem.activePrice) {
            _this5.$set(citem, 'activePrice', 0.01);
          }
          if (!citem.quotaShow) {
            _this5.$set(citem, 'quotaShow', 0);
          }
        });
      });
      this.productList = row;
    },
    setActivePrice: function setActivePrice(item, V) {
      var _this6 = this;
      item.attrValue.forEach(function (item) {
        _this6.$set(item, 'activePrice', V);
      });
      this.$set(item, 'inputPrice', '');
    },
    colosePrice: function colosePrice(item) {
      this.$set(item, 'inputPrice', '');
    },
    setQuotaShow: function setQuotaShow(item, V) {
      var _this7 = this;
      item.attrValue.forEach(function (item) {
        _this7.$set(item, 'quotaShow', V);
      });
      this.$set(item, 'inputNum', '');
    },
    coloseNum: function coloseNum(item) {
      this.$set(item, 'inputNum', '');
    },
    // 提交
    submitForm: function submitForm(formName) {
      var _this8 = this;
      this.$refs[formName].validate(function (valid) {
        if (valid) {
          var total = 0;
          var price = 0;
          _this8.productList.map(function (item) {
            item.attrValue.forEach(function (i) {
              total += i.quotaShow;
              price += i.activePrice;
            });
          });
          if (!total && total !== 0) return _this8.$message.warning('商品限量不能为空');
          if (!price) return _this8.$message.warning('商品拼团价格不能为空');
          if (total < _this8.productList.length) return _this8.$message.warning('商品限量总和不能小于0');
          if (_this8.productList.length > 10) return _this8.$message.warning('最多添加10个商品');
          var arr = [];
          _this8.productList.forEach(function (item) {
            item.attrValue.forEach(function (val) {
              arr.push({
                activePrice: val.activePrice,
                productId: val.productId,
                quotaShow: val.quotaShow,
                skuId: val.skuId ? val.skuId : val.id,
                id: _this8.type == 1 ? val.id : '',
                groupActivityId: _this8.$route.params.activityId ? _this8.$route.params.activityId : ''
              });
            });
          });
          _this8.formData.groupBuySkuRequest = arr;
          _this8.formData.productCount = _this8.productList.length;
          if (_this8.type == 1) {
            (0, _group.groupBuyUpdate)(_this8.formData).then(function (res) {
              _this8.$message.success('修改成功');
              _this8.$router.push({
                path: '/marketing/group/activity/3'
              });
            }).catch(function (err) {
              _this8.$message.error(err);
            });
          } else {
            (0, _group.groupBuySave)(_this8.formData).then(function (res) {
              _this8.$message.success('添加成功');
              _this8.$router.push({
                path: '/marketing/group/activity/3'
              });
            }).catch(function (err) {
              _this8.$message.error(err);
            });
          }
        } else {
          _this8.$message.warning('请填写基础设置');
          return false;
        }
      });
    }
  }
};